import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import { User } from "../../../userTypes";
import RiskAssessmentCreateButton from "./RiskAssessmentCreateButton";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";

type Props = {
  external_reference: string;
  onUserChanged: (user: User) => void;
  getUser?: any;
  createUserRiskAssessment?: any;
};

type State = {
  fetchingData: Boolean;
};

class RiskAssessmentCreateButtonContainer extends React.Component<
  Props,
  State
> {
  state = {
    fetchingData: false,
  };

  hasRequiredUserAttributes = (): boolean => {
    return (
      this.props.getUser.user?.identity_number &&
      this.props.getUser.user?.nationality &&
      this.props.getUser.user?.country_of_residence
    );
  };

  createAssessment = async () => {
    this.setState({ fetchingData: true });
    await this.props.createUserRiskAssessment();
    this.setState({ fetchingData: false });
  };

  render() {
    return (
      <>
        <BOGraphQLLoader data={this.props.getUser!}>
          <RiskAssessmentCreateButton
            user={this.props.getUser.user}
            onUserChanged={this.props.onUserChanged}
            onClick={this.createAssessment}
            disabled={
              !this.hasRequiredUserAttributes() || this.state.fetchingData
                ? true
                : false
            }
            fetchingData={this.state.fetchingData}
          />
        </BOGraphQLLoader>
      </>
    );
  }
}

const getUserQuery = graphql<any, Props>(
  gql`
    query user($external_reference: ID) {
      user(external_reference: $external_reference) {
        external_reference
        identity_number
        country_of_residence
        nationality
      }
    }
  `,
  {
    name: "getUser",
    options(props: Props) {
      return {
        variables: {
          external_reference: props.external_reference,
        },
      };
    },
  }
);

const createUserRiskAssessmentMutation = graphql(
  gql`
    mutation createUserRiskAssessment($externalReference: String!) {
      create_user_risk_assessment(external_reference: $externalReference)
    }
  `,
  {
    name: "createUserRiskAssessment",
    options: (props: Props) => {
      return {
        variables: {
          externalReference: props.external_reference,
        },
      };
    },
  }
);

const riskAssessmentCreateButtonContainerWithMutation = createUserRiskAssessmentMutation(
  RiskAssessmentCreateButtonContainer
);
const RiskAssessmentCreateButtonContainerWithData = getUserQuery(
  riskAssessmentCreateButtonContainerWithMutation
);
export {
  RiskAssessmentCreateButtonContainerWithData,
  RiskAssessmentCreateButtonContainer,
};
